import _str from "shared/util/_str";

export const FIELD_GENDER = "gender";
export const FIELD_ORIENTATION = "orientation";
export const MAX_TAGS = 5;
export const SELECT_TAGS_HEADER = _str(`Select up to ${MAX_TAGS}`);
export const UNDERLYING_HEADER = {
	[FIELD_ORIENTATION]: _str("I'm interested in"),
	[FIELD_GENDER]: _str("Include me in"),
};

export const FIELDS = [
	FIELD_GENDER,
	FIELD_ORIENTATION,
];

export const SUBFIELD = {
	nonbinary: "nonbinary",
	underlying: "underlying",
};

export const UNDERLYING_SUBHEADER = _str("Pick one");
export const UNDERLYING_DETAIL = _str("We know gender is not binary, and it doesn’t feel great to have to choose between these two options. We want you to feel like yourself here, so we’re working on changing this.");



// WEBPACK FOOTER //
// ./src/apps/nonbinary/util/constants.js